<template>
  <div class="tooltip-content">
    <el-button
      type="text"
      class="text-primary border-none tooltip-close"
      icon="el-icon-close"
      @click="$emit('close')"
    />
    <div class="wrapper-dictionary">
      <div class="indicator"></div>
      <div class="vocab-text source-text">{{ dictionary.regularForm }}</div>

      <DictionaryData :dictionary="dictionaryData" />
    </div>
    <div :class="['save-btn', { inactive: dictionary.recordExist }]">
      <img :src="saveBtn" /> {{ buttonLabel }}
    </div>
  </div>
</template>

<script>
import DictionaryData from '@/components/Dictionary/Data';

export default {
  components: { DictionaryData },
  props: {
    dictionary: {
      type: Object,
      required: true,
    },

    showTooltip: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    buttonLabel() {
      return !this.dictionary.recordExist
        ? this.$t('vocabulary.tooltip.saveLabel')
        : this.$t('vocabulary.tooltip.savedLabel');
    },
    dictionaryData() {
      return this.dictionary.dictionary;
    },
    saveBtn() {
      return require('@/assets/img/download.svg');
    },
  },
};
</script>
